import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

@Component({
  selector: 'search-result-highlights',
  templateUrl: './search-result-highlights.component.html',
  styleUrl: './search-result-highlights.component.scss',
  host: {
    '[hidden]': '!hasItems()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchResultHighlights {
  readonly highlights = input.required<Record<string, string>>();

  protected readonly items = computed(() =>
    Object.values(this.highlights() ?? {}),
  );

  protected readonly hasItems = computed(
    () => Object.keys(this.highlights()).length > 0,
  );
}
